import { DatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/th";
import buddhistEra from "dayjs/plugin/buddhistEra";
import thBEPicker from "../utils/locale/th_BE_picker"; // locale ที่ panel แสดงปี พ.ศ.

dayjs.locale("th");
dayjs.extend(buddhistEra);

const toThaiDigits = (s) => s.replace(/\d/g, (d) => "๐๑๒๓๔๕๖๗๘๙"[d]);

function formatThaiDateBE(
  value,
  { thaiDigits = false, longMonth = false } = {}
) {
  if (!value) return "";
  const d = value.locale("th");
  const dd = d.format("DD");
  const month = d.format(longMonth ? "MMMM" : "MMM");
  const yearBE = d.year() + 543;
  let str = `${dd} ${month} ${yearBE}`;
  return thaiDigits ? toThaiDigits(str) : str;
}

function formatThaiMonthBE(
  value,
  { thaiDigits = false, longMonth = true } = {}
) {
  if (!value) return "";
  const d = value.locale("th");
  const month = d.format(longMonth ? "MMMM" : "MMM");
  const yearBE = d.year() + 543;
  let str = `${month} ${yearBE}`;
  return thaiDigits ? toThaiDigits(str) : str;
}

/** ------------------ วันเดียว (DD MMM BBBB) ------------------ */
export default function ThaiDatePicker({
  value,
  onChange,
  thaiDigits = false,
  longMonth = false,
  inputReadOnly = true,
  placeholder = "เลือกวันที่ (พ.ศ.)",
  ...props
}) {
  return (
    <DatePicker
      locale={thBEPicker}
      value={value}
      onChange={onChange}
      format={(v) => formatThaiDateBE(v, { thaiDigits, longMonth })}
      placeholder={placeholder}
      allowClear
      inputReadOnly={inputReadOnly}
      {...props}
    />
  );
}

/** ------------------ ช่วงวัน (DD MMM BBBB – DD MMM BBBB) ------------------ */
export function ThaiRangePicker({
  value,
  onChange,
  thaiDigits = false,
  longMonth = false,
  inputReadOnly = true,
  placeholder = ["วันที่เริ่ม (พ.ศ.)", "วันที่สิ้นสุด (พ.ศ.)"],
  ...props
}) {
  const { RangePicker } = DatePicker;
  return (
    <RangePicker
      locale={thBEPicker}
      value={value}
      onChange={onChange}
      format={(v) => formatThaiDateBE(v, { thaiDigits, longMonth })}
      placeholder={placeholder}
      allowClear
      inputReadOnly={inputReadOnly}
      {...props}
    />
  );
}

/** ------------------ เดือนเดียว (MMMM BBBB) ------------------ */
export function ThaiMonthPicker({
  value,
  onChange,
  thaiDigits = false,
  longMonth = true, // ค่าเริ่มต้น: แสดงชื่อเดือนเต็ม
  inputReadOnly = true,
  placeholder = "เลือกเดือน (พ.ศ.)",
  ...props
}) {
  return (
    <DatePicker
      picker="month"
      locale={thBEPicker}
      value={value}
      onChange={onChange}
      format={(v) => formatThaiMonthBE(v, { thaiDigits, longMonth })}
      placeholder={placeholder}
      allowClear
      inputReadOnly={inputReadOnly}
      {...props}
    />
  );
}

/** ------------------ ช่วงเดือน (MMMM BBBB – MMMM BBBB) ------------------ */
export function ThaiMonthRangePicker({
  value,
  onChange,
  thaiDigits = false,
  longMonth = true,
  inputReadOnly = true,
  placeholder = ["เดือนเริ่ม (พ.ศ.)", "เดือนสิ้นสุด (พ.ศ.)"],
  ...props
}) {
  const { RangePicker } = DatePicker;
  return (
    <RangePicker
      picker="month"
      locale={thBEPicker}
      value={value}
      onChange={onChange}
      format={(v) => formatThaiMonthBE(v, { thaiDigits, longMonth })}
      placeholder={placeholder}
      allowClear
      inputReadOnly={inputReadOnly}
      {...props}
    />
  );
}
